import { render, staticRenderFns } from "./DashboardTrafficChartPage.vue?vue&type=template&id=628d848c&"
import script from "./DashboardTrafficChartPage.vue?vue&type=script&lang=js&"
export * from "./DashboardTrafficChartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports